
import React, { useState } from 'react';
import { Package } from 'lucide-react';
import MainLayout from '@/components/layout/MainLayout';
import ServiceTable from '@/components/services/ServiceTable';
import { useServices } from '@/hooks/useServices';
import TablePagination from '@/components/ui/TablePagination';
import { useLanguage } from '@/hooks/useLanguage';

const ITEMS_PER_PAGE = 10;

const Services: React.FC = () => {
  const { translate } = useLanguage();
  const { data: services = [], isLoading, error } = useServices();
  const [currentPage, setCurrentPage] = useState(1);

  // Pagination logic
  const totalPages = Math.ceil((services?.length || 0) / ITEMS_PER_PAGE);
  const paginatedServices = services?.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  ) || [];

  return (
    <MainLayout>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold tracking-tight">{translate('services.title')}</h1>
            <p className="text-muted-foreground">
              {translate('services.subtitle')}
            </p>
          </div>
        </div>

        {error && (
          <div className="p-4 border border-destructive text-destructive rounded-md">
            Error loading services: {error.message}
          </div>
        )}

        <ServiceTable 
          services={paginatedServices} 
          isLoading={isLoading} 
        />

        {/* Pagination */}
        {services?.length > 0 && (
          <div className="mt-4 flex justify-center">
            <TablePagination 
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default Services;
